import { useState } from "react"

export default function ProductSelector(props){

    const [isHovered, setIsHovered] = useState(false)
    const isSelected = props.index === props.selected


    const onColorBorder = "#4f46e5"

    const bkgWhite = isHovered || isSelected ? '#e0f2fe' : '#ffffff'


    return(
        <div className={`product-selector service-card`} 
            style={{backgroundColor: bkgWhite, border: "5px", 
                borderColor: (isHovered || isSelected) ? onColorBorder : '',
                marginTop: !props.isLargeScreen ? "20px" : 0}} 
            onClick={props.handleClick}
            onMouseOver={() => {setIsHovered(true)}}
            onMouseOut={() => {setIsHovered(false)}}>
            <img src={props.src} alt={props.name} style={{width: "100px", height: "100px"}}/>
            <p style={{textAlign: "center", fontWeight: "650", 
                width: "75%", height: "40px"}}>{props.title}</p>
        </div>
    )
}